(() => {
  if (!window.BskLocalOfferCart) return;
  const dialog = document.querySelector('[data-bsk-offer]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const marker = '2C20-LOCAL-V1';
  const drawer = document.querySelector('[data-bsk-cart-drawer]');
  const discountCode = drawer?.dataset.bskOfferDiscountCode?.trim() || '';
  if (!discountCode) return;
  let checkoutPending = false;
  let checkoutIssue = '';
  let cartSync = Promise.resolve();
  const checkoutPass = new WeakSet();
  const seen = new Set();
  const state = { open: false, busy: false, paused: false, pauseFocus: null, pauseScroll: 0, pendingCart: null, generation: 0, retry: 0, root: null, context: null, group: null, cart: null, selection: null, catalog: null, opener: null, observer: null, frame: 0, currency: 'TRY' };
  const node = (name) => dialog.querySelector(`[data-bsk-offer-${name}]`);
  const money = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency: state.currency || 'TRY' }).format(Number(amount || 0) / 100);
  const ref = (item) => String(item.properties?._bsk_ref || item.properties?._bsk_bundle_id || '').split(':')[0];
  const addon = (item) => String(item.properties?._bsk_ref || '').split(':')[1] === 'A' || item.properties?._bsk_addon === 'true';
  const isOfferItem = (item) => item?.properties?._bsk_offer === marker;
  const letterOf = (item) => Object.entries(item.properties || {}).find(([key, value]) => value && key.trim().toLocaleLowerCase('tr-TR') === 'harf')?.[1]
    || (item.options_with_values || []).find((option) => String(option.name).toLocaleLowerCase('tr-TR') === 'harf')?.value || '';
  const basePrice = (item) => Number(item.original_price ?? item.price ?? item.final_price ?? 0);
  const pairSaving = (first, second) => Math.round(Math.min(Math.max(0, Number(first || 0)), Math.max(0, Number(second || 0))) * .2);
  const firstPrice = () => Number(state.group.lead.final_price ?? state.group.lead.price ?? basePrice(state.group.lead));
  const hasOffer = (cart) => (cart?.items || []).some(isOfferItem);
  const canOffer = (item, cart) => {
    if (!item || !cart || hasOffer(cart) || addon(item) || !ref(item)) return false;
    if (Number(cart.total_discount || 0) > 0) return false;
    const title = String(item.product_title || item.title || '').toLocaleLowerCase('tr-TR');
    if (!/fincan|kupa/.test(title) || /takım|seti|ikili/.test(title)) return false;
    return (cart.items || []).filter((line) => !addon(line)).reduce((sum, line) => sum + Number(line.quantity || 0), 0) === 1;
  };
  // Each configured add has its own bundle reference. Emptying/reusing a cart
  // must not suppress the next first-product offer, or replay this same add.
  const seenKey = (cart) => `bsk_offer_2c20_add:${ref(cart.items?.find((item) => !addon(item)) || {})}`;
  const wasSeen = (cart) => {
    const key = seenKey(cart);
    try { return seen.has(key) || sessionStorage.getItem(key) === '1'; }
    catch (_) { return seen.has(key); }
  };
  const markSeen = (cart) => {
    const key = seenKey(cart);
    seen.add(key);
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  };
  const otherModalVisible = () => Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"]')).some((element) => {
    if (element === dialog || dialog.contains(element)) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width <= 1 || rect.height <= 1 || rect.right <= 0 || rect.bottom <= 0 || rect.left >= innerWidth || rect.top >= innerHeight) return false;
    for (let parent = element; parent; parent = parent.parentElement) {
      const style = getComputedStyle(parent);
      if (parent.hidden || parent.getAttribute('aria-hidden') === 'true' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.display === 'none' || Number(style.opacity) <= .01) return false;
    }
    return true;
  });
  // Yield the native top layer, not the form: signup must remain clickable and
  // closing it must restore the exact offer selections, notes and scroll state.
  const coordinateOverlays = () => {
    state.frame = 0;
    if (!state.open && !state.pendingCart) return;
    if (otherModalVisible()) {
      if (state.open && !state.paused) {
        state.paused = true;
        state.pauseFocus = dialog.contains(document.activeElement) ? document.activeElement : null;
        state.pauseScroll = dialog.querySelector('.bsk-offer__body').scrollTop;
        document.documentElement.classList.remove('bsk-offer-open');
        if (dialog.open) dialog.close();
      }
      return;
    }
    if (state.open && state.paused) {
      state.paused = false;
      syncViewport();
      document.documentElement.classList.add('bsk-offer-open');
      dialog.showModal();
      dialog.querySelector('.bsk-offer__body').scrollTop = state.pauseScroll;
      const focus = state.pauseFocus?.isConnected && !state.pauseFocus.disabled ? state.pauseFocus : document.getElementById('BskOfferTitle');
      focus.focus({ preventScroll: true });
      announce('Teklifine kaldığın yerden devam edebilirsin. Seçimlerin korundu.');
    } else if (!state.open && state.pendingCart) {
      const pending = state.pendingCart;
      state.pendingCart = null;
      void showCart(pending.context, pending.opener);
    }
  };
  const scheduleOverlays = () => {
    if ((!state.open && !state.pendingCart) || state.frame) return;
    state.frame = requestAnimationFrame(coordinateOverlays);
  };
  const announce = (message) => { node('live').textContent = message; };
  const syncViewport = () => { dialog.style.setProperty('--bsk-offer-viewport', `${window.visualViewport?.height || window.innerHeight}px`); };
  const syncCheckout = () => {
    const previewBar = document.getElementById('PBarNextFrame')?.getBoundingClientRect();
    const previewSpace = previewBar && previewBar.height > 0 && previewBar.bottom >= window.innerHeight - 1
      ? Math.min(80, Math.max(0, window.innerHeight - previewBar.top)) : 0;
    drawer?.style.setProperty('--bsk-preview-bar-space', `${previewSpace}px`);
    document.querySelector('[data-bsk-local-offer-notice]')?.remove();
    document.querySelectorAll('[data-bsk-cart-checkout-form] button, .bsk-cart-page button[name="checkout"]').forEach((button) => {
      const busy = checkoutPending || Boolean(drawer?.classList.contains('is-busy'));
      button.disabled = busy;
      button.setAttribute('aria-disabled', String(busy));
      if (button.getAttribute('aria-describedby') === 'BskLocalOfferNotice') button.removeAttribute('aria-describedby');
      const label = button.querySelector('span');
      if (label) label.textContent = busy ? 'Sepetin kontrol ediliyor…' : 'Güvenli ödemeye geç';
      else button.textContent = busy ? 'Sepetin kontrol ediliyor…' : 'Güvenli ödemeye geç';
    });
    let message = document.querySelector('[data-bsk-offer-checkout-message]');
    if (!message && checkoutIssue) {
      message = document.createElement('p');
      message.dataset.bskOfferCheckoutMessage = '';
      message.setAttribute('role', 'status');
      message.style.cssText = 'margin:10px 0;font-size:12px;line-height:1.5;color:var(--ink)';
      document.querySelector('[data-bsk-cart-checkout-form]')?.after(message);
    }
    if (message) { message.textContent = checkoutIssue; message.hidden = !checkoutIssue; }
  };
  const ownDiscount = (application) => [discountCode.toLocaleLowerCase('tr-TR'), 'ikili fincan fırsatı %20'].includes(String(application?.code || application?.title || '').toLocaleLowerCase('tr-TR'));
  const allocations = (item) => item.line_level_discount_allocations || [];
  const hasAppliedDiscount = (cart) => (cart.items || []).some((item) => allocations(item).some((allocation) => ownDiscount(allocation.discount_application) && Number(allocation.amount) > 0)
    || (item.discounts || []).some((discount) => ownDiscount(discount) && Number(discount.amount) > 0));
  const hasPair = (cart) => (cart.items || []).some((item) => isOfferItem(item) && !addon(item) && Number(item.quantity) > 0
    && cart.items.some((parent) => !addon(parent) && !isOfferItem(parent) && ref(parent) === item.properties._bsk_offer_parent && Number(parent.quantity) > 0));
  const currentCodes = (cart) => [...new Set([
    ...(cart.discount_codes || []).map((entry) => typeof entry === 'string' ? entry : entry.code),
    ...(cart.cart_level_discount_applications || []).filter((entry) => entry.type === 'discount_code').map((entry) => entry.title),
    ...(cart.items || []).flatMap((item) => allocations(item).map((entry) => entry.discount_application).filter((entry) => entry?.type === 'discount_code').map((entry) => entry.title))
  ].filter(Boolean))];
  const syncCart = (incoming) => {
    const run = cartSync.catch(() => {}).then(async () => {
      let cart = incoming;
      const pair = hasPair(cart);
      const codes = currentCodes(cart);
      const ownsCode = codes.some((code) => code.toUpperCase() === discountCode.toUpperCase()) || hasAppliedDiscount(cart);
      checkoutPending = true;
      checkoutIssue = '';
      syncCheckout();
      try {
        if ((pair && !hasAppliedDiscount(cart)) || (!pair && ownsCode)) {
          const retained = codes.filter((code) => code.toUpperCase() !== discountCode.toUpperCase());
          if (pair) retained.push(discountCode);
          const response = await fetch(`${(window.routes?.cart_url || '/cart').replace(/\/$/, '')}/update.js`, {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: retained.join(',') })
          });
          if (!response.ok) throw new Error('Discount unavailable');
          cart = await response.json();
        }
        if (hasPair(cart) && !hasAppliedDiscount(cart) && Number(cart.total_discount || 0) === 0) {
          checkoutIssue = 'İkili indirimin şu an doğrulanamadı. Ödemeye geç düğmesiyle tekrar kontrol edebilir veya ikinci ürünü sepetten kaldırabilirsin. Seçimlerin korunuyor.';
        }
      } catch (_) {
        checkoutIssue = 'İndirim kontrolü tamamlanamadı. Seçimlerin korunuyor; ödemeye geç düğmesiyle tekrar deneyebilirsin.';
      } finally { checkoutPending = false; syncCheckout(); }
      return cart;
    });
    cartSync = run;
    return run;
  };
  const priceCart = (cart) => {
    syncCheckout();
    if (!cart) return cart;
    const copy = JSON.parse(JSON.stringify(cart));
    const applied = hasAppliedDiscount(copy);
    copy.items.forEach((item) => {
      item._bskLocalOfferActive = allocations(item).some((entry) => ownDiscount(entry.discount_application) && Number(entry.amount) > 0)
        || (item.discounts || []).some((entry) => ownDiscount(entry) && Number(entry.amount) > 0);
      item._bskLocalOfferQualified = isOfferItem(item) && applied && hasPair(copy);
    });
    return copy;
  };
  const lineLabel = (item) => item?._bskLocalOfferActive
    ? 'İkili fırsatı · %20 indirim'
    : !isOfferItem(item) ? '' : item._bskLocalOfferQualified
      ? 'İndirim, ikilinin düşük fiyatlı ürününe uygulandı.'
      : 'Geçerli indirim ve toplam sepetinde gösterilir. Kampanyalar birleştirilmez.';
  const showCart = async (context, opener) => {
    if (otherModalVisible()) {
      state.pendingCart = { context, opener };
      return;
    }
    await context.openCart(opener);
    syncCheckout();
    const heading = document.getElementById('BskCartDrawerTitle');
    if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
  };
  const clearSurface = () => {
    state.generation += 1;
    state.context?.cancelLoad();
    state.catalog?.destroy();
    state.catalog = null;
    state.selection = null;
    state.observer?.disconnect();
    state.observer = null;
    if (state.frame) cancelAnimationFrame(state.frame);
    state.frame = 0;
    state.open = false;
    state.busy = false;
    state.paused = false;
    state.pauseFocus = null;
    state.pendingCart = null;
    state.root = null;
    document.documentElement.classList.remove('bsk-offer-open');
    dialog.classList.remove('is-open');
    if (dialog.open) dialog.close();
  };
  const dismiss = async () => {
    if (!state.open || state.busy) return;
    const context = state.context;
    const opener = state.opener;
    clearSurface();
    await showCart(context, opener);
  };
  const focusLetters = () => {
    const grid = state.root?.querySelector('.bsk-letter-grid');
    grid?.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    (grid?.querySelector('[aria-pressed="true"]:not(:disabled)') || grid?.querySelector('button:not(:disabled)'))?.focus({ preventScroll: true });
  };
  const updatePriceSummary = (base, extras = 0) => {
    const cartTotal = Number(state.cart.total_price || 0);
    const cartOriginal = Math.max(cartTotal, Number(state.cart.original_total_price ?? cartTotal));
    const existingSavings = cartOriginal - cartTotal;
    const offerSavings = pairSaving(firstPrice(), base);
    const normalTotal = cartOriginal + base + extras;
    const finalTotal = cartTotal + base + extras - offerSavings;
    node('normal-total').textContent = money(normalTotal);
    node('normal-total-compact').textContent = money(normalTotal);
    node('existing-discount-row').hidden = existingSavings <= 0;
    node('existing-discount').textContent = `−${money(existingSavings)}`;
    node('second-discount').textContent = `−${money(offerSavings)}`;
    node('total-savings').textContent = `Toplam ${money(existingSavings + offerSavings)} tasarruf`;
    node('total').textContent = money(finalTotal);
  };
  const syncLetterPresentation = (requiresLetter) => {
    node('eyebrow').textContent = 'İKİ ÜRÜN. UYGUN FİYATLIYA %20.';
    node('heading-start').textContent = 'Birlikte';
    node('heading-end').textContent = 'daha güzel.';
    node('intro').textContent = 'İkilide';
    node('choice-hint').textContent = requiresLetter ? ' Aynı model, sana özel başka bir harf.' : ' İstersen not ve paket ekle.';
    node('pair').setAttribute('aria-label', 'Sepetindeki ilk ürün ve seçtiğin ikinci ürün');
    node('first-chip').hidden = !letterOf(state.group.lead);
    node('pick-letter').hidden = !requiresLetter;
    node('photo-note').textContent = requiresLetter ? 'Fotoğraflar modelleri gösterir; harfler seçimindir.' : 'Fotoğraflar seçili ürün modellerini gösterir.';
    node('unit-label').textContent = 'Seçtiğin ikinci ürün';
    node('scope').textContent = 'İki ana üründen uygun fiyatlı olana %20 indirim. Paket ve diğer ek seçenekler tam fiyat.';
    node('discount-label').textContent = 'Uygun fiyatlı üründe %20';
  };
  const previewSelection = () => {
    const product = state.selection;
    node('model').textContent = product.title;
    node('second-image').hidden = !product.image;
    if (product.image) node('second-image').src = product.image;
    node('variant-label').hidden = true;
  };
  const updateUnitPricing = (base, extras = 0) => {
    const saving = pairSaving(firstPrice(), base);
    const firstIsCheaper = firstPrice() < base;
    node('base').hidden = firstIsCheaper || saving === 0;
    node('base').textContent = money(base);
    node('price').textContent = money(base - (firstIsCheaper ? 0 : saving));
    node('saving').textContent = `İkilide ${money(saving)} tasarruf`;
    node('discount-target').textContent = `İndirim ${firstIsCheaper ? 'sepetteki ilk ürüne' : 'seçtiğin ikinci ürüne'} uygulanır.`;
    updatePriceSummary(base, extras);
  };
  const selectProduct = (product) => {
    if (!state.open || state.busy || String(product.id) === String(state.selection?.id)) return;
    state.context.cancelLoad();
    state.observer?.disconnect();
    state.observer = null;
    state.root = null;
    state.selection = product;
    state.retry = 0;
    syncLetterPresentation(false);
    previewSelection();
    updateUnitPricing(product.price);
    void loadForm();
  };
  const updatePricing = () => {
    const root = state.root;
    if (!state.open || !root) return;
    const base = Number(root.dataset.bskBasePrice || 0);
    const extras = Array.from(root.querySelectorAll('[data-bsk-addon-variant-id]:checked')).filter((input) => !input.disabled).reduce((sum, input) => sum + Number(input.dataset.bskAddonPrice || 0), 0);
    const requiresLetter = root.dataset.bskRequiresLetter === 'true';
    const letter = root.querySelector('[data-bsk-letter-input]')?.value || '';
    syncLetterPresentation(requiresLetter);
    updateUnitPricing(base, extras);
    const letterPosition = Number(root.dataset.bskLetterOptionPosition || 0);
    const variantLabel = Array.from(root.querySelectorAll('[data-bsk-option]')).filter((select) => Number(select.dataset.bskOptionPosition) !== letterPosition).map((select) => `${select.closest('label')?.querySelector('span')?.textContent || 'Seçenek'}: ${select.value}`).join(' · ');
    node('variant-label').textContent = variantLabel;
    node('variant-label').hidden = !variantLabel;
    node('second-glyph').textContent = letter || '?';
    node('chip-label').textContent = letter ? 'Yeni fincan' : 'Harfini seç';
    node('pick-letter').classList.toggle('is-selected', Boolean(letter));
    node('pick-letter').setAttribute('aria-label', letter ? `Yeni fincanın harfi ${letter}. Değiştirmek için harf seç.` : 'Yeni fincanın harfini seç');
    const actual = root.querySelector('[data-bsk-add-button]');
    const accept = node('accept');
    accept.disabled = state.busy || !actual || actual.disabled;
    accept.textContent = state.busy ? 'Ekleniyor…' : actual?.disabled ? actual.textContent : requiresLetter && !letter ? 'Yeni ürünün harfini seç' : 'Seçtiğim ürünü ekle';
    const configured = root.querySelector('[data-bsk-configured-total]');
    if (configured) configured.textContent = money(base + extras);
    const selectedCount = root.querySelector('[data-bsk-offer-extras-count]');
    const count = root.querySelectorAll('[data-bsk-addon-variant-id]:checked').length;
    if (selectedCount) selectedCount.textContent = count ? `${count} seçili` : 'İsteğe bağlı';
    const grid = root.querySelector('.bsk-letter-grid');
    if (letter) grid?.removeAttribute('aria-invalid');
  };
  const schedulePricing = () => queueMicrotask(updatePricing);
  const prepareForm = (root) => {
    state.root = root;
    root.dataset.bskOfferProduct = '';
    root.dataset.bskOfferParent = ref(state.group.lead);
    root.querySelector('.bsk-second-cup__product')?.remove();
    const form = root.querySelector('[data-bsk-product-form]');
    let profile = form.querySelector('[data-bsk-profile-options]');
    if (!profile) {
      profile = document.createElement('div');
      profile.className = 'bsk-profile-options';
      profile.dataset.bskProfileOptions = '';
      form.prepend(profile);
    }
    const letterModule = root.querySelector('[data-bsk-letter-module]');
    const title = letterModule?.querySelector('.bsk-product__picker-title');
    if (title) {
      const label = document.createElement('strong');
      label.append('Yeni fincanın harfi: ');
      const output = document.createElement('b');
      output.dataset.bskLetterOutput = '';
      label.append(output);
      title.replaceChildren(label);
    }
    const letterPosition = Number(root.dataset.bskLetterOptionPosition || 0);
    const controls = Array.from(root.querySelectorAll('[data-bsk-option]'));
    controls.forEach((select) => {
      if (Number(select.dataset.bskOptionPosition) !== letterPosition) select.closest('label').hidden = true;
    });
    const variants = JSON.parse(root.querySelector('[data-bsk-product-variants]').textContent);
    const selectedOptions = controls.map((select) => select.value);
    root.querySelectorAll('[data-bsk-letter]').forEach((button, index) => {
      button.setAttribute('aria-label', `Harf ${button.dataset.bskLetter}`);
      button.tabIndex = index === 0 ? 0 : -1;
      if (letterPosition > 0) {
        const variant = variants.find((candidate) => candidate.options.every((value, position) => value === (position === letterPosition - 1 ? button.dataset.bskLetter : selectedOptions[position])));
        button.disabled = !variant?.available;
      }
    });
    const firstAvailable = root.querySelector('[data-bsk-letter]:not(:disabled)');
    if (root.dataset.bskRequiresLetter === 'true' && !firstAvailable) throw new Error('Bu fincandan ikinci adet şu an eklenemiyor. Sepetindeki fincan güvende.');
    if (firstAvailable) firstAvailable.tabIndex = 0;
    const note = root.querySelector('.bsk-product__gift-note');
    if (note) {
      const details = document.createElement('details');
      details.className = 'bsk-offer__note';
      const summary = document.createElement('summary');
      summary.textContent = 'Hediye notu ekle';
      const free = document.createElement('small');
      free.textContent = 'Ücretsiz';
      summary.append(free);
      details.append(summary, note);
      const textarea = note.querySelector('textarea');
      if (textarea) {
        textarea.placeholder = 'Bu fincanla gidecek kısa notun';
        textarea.setAttribute('aria-label', 'İkinci fincanın hediye notu');
      }
      profile.append(details);
    }
    const paid = Array.from(root.querySelectorAll('.bsk-product__extras, .bsk-gift-packages'));
    if (paid.length) {
      const details = document.createElement('details');
      details.className = 'bsk-offer__extras';
      const summary = document.createElement('summary');
      summary.textContent = 'Paket ve ek seçenekler';
      const count = document.createElement('small');
      count.dataset.bskOfferExtrasCount = '';
      count.textContent = 'İsteğe bağlı';
      summary.append(count);
      details.append(summary, ...paid);
      profile.append(details);
    }
    const doubleVariant = document.querySelector('[data-bsk-cart-drawer]')?.dataset.bskPremiumDoubleVariantId;
    if (state.group.addons.some((item) => String(item.variant_id) === doubleVariant)) {
      const note = document.createElement('p');
      note.className = 'bsk-offer__pair-note';
      note.textContent = 'Premium İkili kutun varsa ikinci ürünü aynı hacimde seçmelisin. Farklı hacimlerde ayrı kutu gerekir; kutu seçimini sepette değiştirebilirsin.';
      profile.append(note);
    }
    form.addEventListener('invalid', (event) => {
      const details = event.target.closest('details');
      if (details) details.open = true;
    }, true);
    root.addEventListener('change', schedulePricing);
    root.addEventListener('input', schedulePricing);
    root.addEventListener('click', (event) => {
      if (!event.target.closest('[data-bsk-letter]')) return;
      root.querySelectorAll('[data-bsk-letter]').forEach((button) => { button.tabIndex = button === event.target.closest('[data-bsk-letter]') ? 0 : -1; });
      requestAnimationFrame(() => {
        if (!state.open || state.root !== root) return;
        updatePricing();
        const letter = root.querySelector('[data-bsk-letter-input]').value;
        if (letter) announce(`Yeni fincanın harfi: ${letter}`);
      });
    });
    root.addEventListener('keydown', (event) => {
      const current = event.target.closest('[data-bsk-letter]');
      if (!current || !['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const buttons = Array.from(root.querySelectorAll('[data-bsk-letter]:not(:disabled)'));
      const index = buttons.indexOf(current);
      const columns = Math.max(1, getComputedStyle(current.parentElement).gridTemplateColumns.split(/\s+/).filter(Boolean).length);
      const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : event.key === 'ArrowDown' ? columns : -columns;
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + delta + buttons.length) % buttons.length;
      event.preventDefault();
      buttons.forEach((button) => { button.tabIndex = -1; });
      buttons[next].tabIndex = 0;
      buttons[next].focus();
    });
    root.addEventListener('focusin', (event) => {
      if (event.target.matches('textarea,input:not([type="hidden"])') && window.visualViewport && window.visualViewport.height < window.innerHeight * .8) event.target.scrollIntoView({ block: 'center' });
    });
    state.observer = new MutationObserver(updatePricing);
    state.observer.observe(root.querySelector('[data-bsk-add-button]'), { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled'] });
    updatePricing();
  };
  const loadForm = async () => {
    const generation = ++state.generation;
    const content = node('content');
    state.root = null;
    node('accept').disabled = true;
    node('accept').textContent = 'Hazırlanıyor…';
    let timeout;
    try {
      const root = await Promise.race([
        state.context.loadProduct(state.group.id, state.opener, content, state.selection),
        new Promise((_, reject) => { timeout = setTimeout(() => { state.context?.cancelLoad(); reject(new Error('Teklif şu an yüklenemedi. Sepetindeki fincan güvende.')); }, 12000); })
      ]);
      if (!state.open || generation !== state.generation) return;
      if (!root) throw new Error('Teklif şu an yüklenemedi. Sepetindeki fincan güvende.');
      prepareForm(root);
      announce(root.dataset.bskRequiresLetter === 'true' ? 'İkinci fincanın harfini seçebilirsin. İlk fincanın değişmedi.' : 'İkinci ürününü doğrudan ekleyebilirsin. İlk ürünün değişmedi.');
    } catch (error) {
      if (!state.open || generation !== state.generation) return;
      state.root = null;
      content.replaceChildren();
      const box = document.createElement('div');
      box.className = 'bsk-offer__error';
      box.setAttribute('role', 'alert');
      const text = document.createElement('p');
      text.textContent = error.message || 'Teklif şu an yüklenemedi. Sepetindeki fincan güvende.';
      box.append(text);
      if (state.retry < 1) {
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = 'Tekrar dene';
        retry.addEventListener('click', () => { state.retry += 1; loadForm(); });
        box.append(retry);
      }
      content.append(box);
      node('accept').disabled = true;
      node('accept').textContent = 'Teklif yüklenemedi';
    } finally { clearTimeout(timeout); }
  };
  const open = async (context, group, cart, opener) => {
    if (state.open) return true;
    if (!group) return false;
    state.context = context;
    state.group = group;
    state.cart = priceCart(cart);
    state.currency = cart.currency || 'TRY';
    state.opener = opener;
    state.retry = 0;
    state.busy = false;
    state.root = null;
    state.open = true;
    state.paused = true;
    state.pauseFocus = null;
    state.pauseScroll = 0;
    state.pendingCart = null;
    markSeen(cart);
    dialog.querySelector('[data-bsk-offer-price-details]').open = false;
    node('content').replaceChildren();
    const item = group.lead;
    state.selection = {
      id: item.product_id,
      title: item.product_title || item.title,
      url: item.url,
      variant_id: item.variant_id,
      price: basePrice(item),
      image: item.featured_image?.url || item.image || '',
      available: true
    };
    const firstLetter = letterOf(item);
    syncLetterPresentation(Boolean(firstLetter));
    node('first-letter').textContent = firstLetter ? `· Harf ${firstLetter}` : '';
    node('first-glyph').textContent = firstLetter;
    node('second-glyph').textContent = '?';
    node('chip-label').textContent = 'Harfini seç';
    node('pick-letter').classList.remove('is-selected');
    const image = item.featured_image?.url || item.image;
    node('first-image').hidden = !image;
    if (image) node('first-image').src = image;
    previewSelection();
    const base = basePrice(item);
    updateUnitPricing(base);
    dialog.querySelectorAll('[data-bsk-offer-dismiss]').forEach((button) => { button.disabled = false; });
    syncViewport();
    dialog.classList.add('is-open');
    node('content').scrollTop = 0;
    dialog.querySelector('.bsk-offer__body').scrollTop = 0;
    coordinateOverlays();
    void loadForm();
    return true;
  };
  const afterAdd = async (context) => {
    if (state.open) return true;
    if (context.offerAdded) {
      window.BskOfferJourney?.clear();
      await showCart(context, context.opener);
      return true;
    }
    const cart = await context.loadCart();
    if (!cart) return false;
    const group = context.getGroups().find((candidate) => ref(candidate.lead) === context.bundleId);
    if (!group || !canOffer(group.lead, cart)) return false;
    window.BskOfferJourney?.activate(group, cart);
    if (wasSeen(cart)) return false;
    return open(context, group, cart, context.opener);
  };
  const fromDrawer = async (context, groupId, opener) => {
    const cart = context.getCart();
    const group = context.getGroups().find((candidate) => candidate.id === groupId);
    if (!group || !canOffer(group.lead, cart)) return false;
    window.BskOfferJourney?.activate(group, cart);
    context.closeCart();
    return open(context, group, cart, opener);
  };
  const setSubmitting = (busy, error = '') => {
    state.busy = busy;
    state.catalog?.setBusy(busy);
    dialog.querySelectorAll('[data-bsk-offer-dismiss], [data-bsk-offer-pick-letter]').forEach((button) => { button.disabled = busy; });
    if (error && state.root) {
      const message = state.root.querySelector('[data-bsk-product-message]');
      if (message) { message.textContent = error; message.setAttribute('role', 'alert'); }
      announce(error);
    }
    updatePricing();
  };
  const complete = async () => {
    const context = state.context;
    const opener = state.opener;
    const letter = state.root?.dataset.bskRequiresLetter === 'true' ? state.root.querySelector('[data-bsk-letter-input]')?.value || '' : '';
    window.BskOfferJourney?.clear();
    clearSurface();
    await showCart(context, opener);
    const live = document.querySelector('[data-bsk-cart-live]');
    if (live) live.textContent = `${letter ? `İkinci fincan ${letter} harfiyle eklendi.` : 'İkinci ürün sepete eklendi.'} İlk ürününün seçimleri korundu.`;
  };
  window.BskSecondCupOffer = {
    afterAdd, fromDrawer, canOffer, isOfferItem, lineLabel, priceCart, syncCart, syncCheckout, setSubmitting, complete, showCart,
    decorateProperties(properties, root) {
      if (!root.hasAttribute('data-bsk-offer-product')) return;
      properties._bsk_offer = marker;
      properties._bsk_offer_parent = root.dataset.bskOfferParent;
    }
  };
  dialog.querySelectorAll('[data-bsk-offer-dismiss]').forEach((button) => button.addEventListener('click', dismiss));
  node('browse').addEventListener('click', () => {
    if (state.busy) return;
    window.BskOfferJourney?.activate(state.group, state.cart);
    clearSurface();
    window.BskOfferJourney?.browse();
  });
  node('pick-letter').addEventListener('click', focusLetters);
  node('accept').addEventListener('click', () => {
    if (state.busy || !state.root) return;
    const input = state.root.querySelector('[data-bsk-letter-input]');
    if (state.root.dataset.bskRequiresLetter === 'true' && !input?.value) {
      const grid = state.root.querySelector('.bsk-letter-grid');
      grid?.setAttribute('aria-invalid', 'true');
      const message = state.root.querySelector('[data-bsk-product-message]');
      if (message) message.textContent = 'Devam etmek için yeni fincanın harfini seç.';
      announce('Devam etmek için yeni fincanın harfini seç.');
      focusLetters();
      return;
    }
    const form = state.root.querySelector('[data-bsk-product-form]');
    const submit = form.querySelector('[data-bsk-add-button]');
    if (!submit.disabled) form.requestSubmit(submit);
  });
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); if (!state.busy) dismiss(); });
  dialog.addEventListener('close', () => { if (state.open && !state.paused && !dialog.open) { state.busy = false; dismiss(); } });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog || state.busy) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const path = new URL(form.action || location.href, location.href).pathname;
    if (!form.matches('[data-bsk-cart-checkout-form]') && event.submitter?.name !== 'checkout' && !/\/checkouts?(\/|$)/.test(path)) return;
    if (checkoutPass.has(form)) { checkoutPass.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending || drawer?.classList.contains('is-busy')) return;
    const submitter = event.submitter;
    const cart = await window.BskLocalOfferCart.loadCart();
    if (!cart || checkoutIssue) {
      if (!cart) checkoutIssue = 'Sepetin kontrol edilemedi. Lütfen yeniden dene.';
      syncCheckout();
      return;
    }
    checkoutPass.add(form);
    form.requestSubmit(submitter?.isConnected ? submitter : undefined);
    syncCheckout();
  }, true);
  window.visualViewport?.addEventListener('resize', syncViewport);
  window.visualViewport?.addEventListener('scroll', syncViewport);
  const overlayObserver = new MutationObserver(scheduleOverlays);
  overlayObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'aria-modal', 'hidden', 'open', 'style', 'class'] });
  window.addEventListener('klaviyoForms', () => {
    scheduleOverlays();
    [180, 450].forEach((delay) => setTimeout(scheduleOverlays, delay));
  });
  window.addEventListener('pageshow', scheduleOverlays);
  window.addEventListener('resize', scheduleOverlays);
  syncViewport();
  syncCheckout();
})();
